﻿export const DropdownOption = option => {
    const value = option.getAttribute("data-value");
    const css = {
        isSelected: "is-selected",
    };
    return {
        elem: option,
        value: value,
        select() {
            option.classList.add(css.isSelected);
        },
        deselect() {
            option.classList.remove(css.isSelected);
        },
        isSelected() {
            return option.classList.contains(css.isSelected);
        },
    };
};
DropdownOption.selectors = {
    root: ".dropdown__option"
};